import searchResult from '@/view/search/index'
const route = [{
    path: '/search/:short_name'+'/:searchId'+'.html',
    meta: {
      title: '搜索结果页'
    },
    component: searchResult
  }
];

export default route;


// WEBPACK FOOTER //
// ./src/router/branch/search.js